import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { useFieldArray, useForm } from 'react-hook-form'
import {
  type MatchCoursesFormType,
  matchCourseSchema
} from '@/schemas/education/match-courses-schema'
import type { StudentRequestedCoursesFormMethods } from '@/types/forms/student-requested-courses-form-methods'
import type { Request } from '@/types/requests/request'

export const useCreditTransferReviewForms = (request?: Request) => {
  const defaultValues = {
    observation: '',
    serie: ''
  }

  const { control, getValues, reset, watch, handleSubmit, trigger, setValue } =
    useForm<MatchCoursesFormType>({
      defaultValues,
      resolver: zodResolver(matchCourseSchema)
    })

  const { fields, append, remove, update } = useFieldArray({
    control,
    name: 'courseEquivalences'
  })

  function clearDesiredCourses() {
    const currentValues = getValues('courseEquivalences')
    currentValues.forEach((item, index) => {
      if (item) {
        update(index, {
          desiredCourse: {
            name: '',
            workload: 0,
            id: undefined,
            courseId: '',
            period: undefined
          },
          previousCourse: item.previousCourse,
          equivalenceStatus: item.equivalenceStatus,
          selectedByAI: item?.selectedByAI
        })
      }
    })
  }

  useEffect(() => {
    if (request) {
      reset({
        curriculum: request.desiredEducation.curriculum,
        courseEquivalences: request.courseEquivalences,
        automaticCourseEquivalences: [],
        serie: request.desiredEducation.entrySerie
      })
    }
  }, [request, reset])

  const formMethods: StudentRequestedCoursesFormMethods = {
    append,
    remove,
    control,
    getValues,
    reset,
    fields,
    watch,
    handleSubmit,
    trigger,
    setValue
  }

  return {
    states: {
      formMethods
    },
    actions: {
      clearDesiredCourses
    }
  }
}
